import React from 'react';
import './ProfileCard.css';

const ProfileCard = ({isAdmin}) => {
  return (
    <div className='profile-card'>
      <div className='profile-card__rank'>
        <div
          className='profile-card__rank-item profile-card__rank-admin profile-card__rank-item-pointer'
          data-role='user-profile-actions-button'
        >
          <span>{isAdmin ? 'АДМИНИСТРАТОР' : 'ПОЛЬЗОВАТЕЛЬ'}</span>
          <span className='profile-card__rank-item-config'></span>
        </div>
      </div>
      <div className='profile-card__status-info'>
        <div className='profile-card__status profile-card__status-online'>
          В СЕТИ{' '}
        </div>
        <div className='profile-card__last-time'></div>
      </div>{' '}
      <div
        className='profile-card__userpic profile-card__userpic-edit'
        id='profile-card__userpic-avatar'
      >
        <div className='profile-card__photo' id='profile-card__photo'>
          <div className='profile-card__avatar '></div>
        </div>
        <div className='profile-card__userpic-load'>
          <div
            className='profile-card__userpic-create'
            id='profile-card__photo-camera'
          >
            Сделать фото
          </div>
          <div
            className='profile-card__userpic-upload'
            id='profile-card__photo-file'
            data-bx-ui-avatar-editor-info='{""}'
          >
            Загрузить фото
          </div>
        </div>
        <div
          className='profile-card__userpic-remove'
          id='profile-card__photo-remove'
        ></div>
      </div>
    </div>
  );
};

export default ProfileCard;
